import { useQuery } from '@tanstack/react-query';
import { getFaiths } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useFaithsQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'faiths' ],
    queryFn: getFaiths,
    select: (data) => data.data,
    ...opts,
  });
};
